import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "add-order-modal-body" }
const _hoisted_2 = { class: "upper-body" }
const _hoisted_3 = { class: "changing-items" }
const _hoisted_4 = { class: "vertical-container" }
const _hoisted_5 = {
  key: 0,
  class: "show-details-on-invoice"
}
const _hoisted_6 = { for: "multiMonth" }
const _hoisted_7 = { class: "vertical-container" }
const _hoisted_8 = { class: "vertical-container" }
const _hoisted_9 = { class: "show-details-on-invoice" }
const _hoisted_10 = { for: "showDetailsOnInvoice" }
const _hoisted_11 = { class: "lower-body" }
const _hoisted_12 = { class: "order-line-header role" }
const _hoisted_13 = { class: "order-line-header quantity" }
const _hoisted_14 = { class: "order-line-header hourly-rate" }
const _hoisted_15 = { class: "order-line-header subtotal" }
const _hoisted_16 = { class: "total" }
const _hoisted_17 = { class: "total-number" }
const _hoisted_18 = {
  key: 0,
  class: "loading apollo"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BasicToggle = _resolveComponent("BasicToggle")!
  const _component_FormItem = _resolveComponent("FormItem")!
  const _component_OrderLine = _resolveComponent("OrderLine")!
  const _component_BasicButton = _resolveComponent("BasicButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    onClose: _ctx.closeModal,
    size: "lg-fixed",
    class: "add-order"
  }, {
    header: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.t("titles.order.add")), 1)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("form", {
          onSubmit: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.submitForm()), ["prevent"])),
          id: "mutateFrom"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_BasicToggle, {
              class: "basic-toggle",
              isLeft: _ctx.isRecurringOrder,
              "onUpdate:isLeft": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isRecurringOrder) = $event)),
              leftLabel: _ctx.t('labels.toggle.recurring'),
              rightLabel: _ctx.t('labels.toggle.oneShot')
            }, null, 8, ["isLeft", "leftLabel", "rightLabel"]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_FormItem, {
                input: _ctx.order.title,
                "onUpdate:input": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.order.title) = $event)),
                errors: _ctx.v$.title.$errors,
                label: _ctx.t(`labels.order.title`),
                name: "order-title"
              }, null, 8, ["input", "errors", "label"]),
              _withDirectives(_createElementVNode("div", { class: "date-title" }, _toDisplayString(_ctx.t("labels.recurringOrder.firstMonth")) + " : ", 513), [
                [_vShow, _ctx.isRecurringOrder || _ctx.multiMonth]
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_FormItem, {
                  input: _ctx.order.startYear,
                  "onUpdate:input": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.order.startYear) = $event)),
                  errors: _ctx.v$.startYear.$errors,
                  label: _ctx.t(`labels.order.year`),
                  options: _ctx.years,
                  name: "order-start-year"
                }, null, 8, ["input", "errors", "label", "options"]),
                _createVNode(_component_FormItem, {
                  input: _ctx.order.startMonth,
                  "onUpdate:input": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.order.startMonth) = $event)),
                  errors: _ctx.v$.startMonth.$errors,
                  label: _ctx.t(`labels.order.month`),
                  options: _ctx.months,
                  name: "order-start-month"
                }, null, 8, ["input", "errors", "label", "options"])
              ]),
              (!_ctx.isRecurringOrder)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "multiMonth",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.multiMonth) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.multiMonth]
                    ]),
                    _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.t(`labels.order.multiMonth`)), 1)
                  ]))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", { class: "date-title" }, _toDisplayString(_ctx.t("labels.recurringOrder.lastMonth")) + " : ", 513), [
                [_vShow, _ctx.isRecurringOrder || _ctx.multiMonth]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_7, [
                _createVNode(_component_FormItem, {
                  input: _ctx.order.endYear,
                  "onUpdate:input": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.order.endYear) = $event)),
                  errors: _ctx.v$.endYear.$errors,
                  label: _ctx.t(`labels.order.year`),
                  options: _ctx.years,
                  name: "order-end-year"
                }, null, 8, ["input", "errors", "label", "options"]),
                _createVNode(_component_FormItem, {
                  input: _ctx.order.endMonth,
                  "onUpdate:input": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.order.endMonth) = $event)),
                  errors: _ctx.v$.endMonth.$errors,
                  label: _ctx.t(`labels.order.month`),
                  options: _ctx.months,
                  name: "order-end-month"
                }, null, 8, ["input", "errors", "label", "options"])
              ], 512), [
                [_vShow, _ctx.isRecurringOrder || _ctx.multiMonth]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_FormItem, {
                input: _ctx.order.paymentOption,
                "onUpdate:input": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.order.paymentOption) = $event)),
                errors: _ctx.v$.paymentOption.$errors,
                label: _ctx.t(`labels.order.paymentOption`),
                options: _ctx.paymentOptions,
                name: "order-payment-options"
              }, null, 8, ["input", "errors", "label", "options"]),
              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "fill-empty-space" }, null, -1)),
              _createVNode(_component_FormItem, {
                input: _ctx.order.companyId,
                "onUpdate:input": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.order.companyId) = $event)),
                errors: _ctx.v$.companyId.$errors,
                label: _ctx.t(`labels.order.company`),
                options: _ctx.project.client.companies,
                name: "order-company"
              }, null, 8, ["input", "errors", "label", "options"]),
              (_ctx.order.paymentOption === 'pre_paid' && !_ctx.isRecurringOrder)
                ? (_openBlock(), _createBlock(_component_FormItem, {
                    key: 0,
                    input: _ctx.order.dueDate,
                    "onUpdate:input": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.order.dueDate) = $event)),
                    label: _ctx.t(`labels.order.dueDate`),
                    name: "order-dueDate",
                    "input-type": "date"
                  }, null, 8, ["input", "label"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                id: "showDetailsOnInvoice",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.showDetailsOnInvoice) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.showDetailsOnInvoice]
              ]),
              _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.t(`labels.order.showDetailsOnInvoice`)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.t("labels.order.roles")), 1),
                _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.t("labels.order.quantity")), 1),
                _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.t("labels.order.hourlyRate")), 1),
                _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.t("labels.order.subtotal")), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.project.projectRoles, (projectRole, index) => {
                return (_openBlock(), _createBlock(_component_OrderLine, {
                  key: index,
                  projectRoleName: projectRole.name,
                  hourlyRate: projectRole.hourlyRate,
                  validator: _ctx.orderlineV$[index],
                  quantity: _ctx.displayedQuantity[index],
                  "onUpdate:quantity": ($event: any) => (_ctx.onQuantityChange($event, index)),
                  unit: _ctx.units[index],
                  "onUpdate:unit": ($event: any) => ((_ctx.units[index]) = $event),
                  subtotal: _ctx.subtotals[index],
                  "onUpdate:subtotal": ($event: any) => ((_ctx.subtotals[index]) = $event)
                }, null, 8, ["projectRoleName", "hourlyRate", "validator", "quantity", "onUpdate:quantity", "unit", "onUpdate:unit", "subtotal", "onUpdate:subtotal"]))
              }), 128))
            ]),
            _createElementVNode("p", _hoisted_16, [
              _createTextVNode(_toDisplayString(_ctx.t("labels.order.total")) + " ", 1),
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.formatPrice(_ctx.totalPrice)), 1)
            ]),
            _createVNode(_component_FormItem, {
              input: _ctx.order.notes,
              "onUpdate:input": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.order.notes) = $event)),
              errors: _ctx.v$.notes.$errors,
              label: _ctx.t(`labels.order.notes`),
              name: "order-notes",
              "input-type": "textArea"
            }, null, 8, ["input", "errors", "label"]),
            _createVNode(_component_FormItem, {
              input: _ctx.order.legalNotice,
              "onUpdate:input": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.order.legalNotice) = $event)),
              errors: _ctx.v$.legalNotice.$errors,
              label: _ctx.t(`labels.order.legalNotice`),
              name: "order-legalNotice",
              "input-type": "textArea"
            }, null, 8, ["input", "errors", "label"])
          ])
        ], 32)
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.t("loading")), 1))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_BasicButton, {
        type: "submit",
        form: "mutateFrom",
        value: _ctx.t('buttons.order.add'),
        disabled: _ctx.loading,
        class: "add-order-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.isRecurringOrder
            ? _ctx.t("buttons.recurringOrder.add")
            : _ctx.t("buttons.order.add")), 1)
        ]),
        _: 1
      }, 8, ["value", "disabled"]),
      _createVNode(_component_BasicButton, {
        value: _ctx.t('buttons.order.addAndSend'),
        onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.createAndSend()), ["prevent"])),
        disabled: _ctx.loading,
        class: "add-order-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.isRecurringOrder
            ? _ctx.t("buttons.recurringOrder.addAndSend")
            : _ctx.t("buttons.order.addAndSend")), 1)
        ]),
        _: 1
      }, 8, ["value", "disabled"])
    ]),
    _: 1
  }, 8, ["onClose"]))
}